import { getWrapperClassName } from '@/components/design-system/utils'
import React, { ReactNode } from 'react'

type Type = 'primary' | 'secondary'
type Props = Readonly<{
  className?: string
  type?: Type
  action?: 'button' | 'submit'
  children: ReactNode
  onClick: () => void
}>

export const LTButton = (props: Props) => {
  const onClick = e => {
    props.onClick()
    e.preventDefault()
  }

  return (
      <button
          type={ props.action }
          className={ getWrapperClassName(props.className, `${ getButtonStyle(props.type) } rounded-full border-2 font-semibold focus:outline-none`) }
          onClick={ onClick }>
        <p className={ `${ getButtonTextStyle(props.type) } py-3 px-10 transition-all duration-0 hover:duration-200 hover:pl-4 hover:pr-16 max-md:hover:px-10` }>
          { props.children }
        </p>
      </button>
  )

  function getButtonStyle(type: Nullable<Type>): string {
    switch (type) {
      case 'secondary':
        return 'border-white transition-all duration-0 hover:duration-200 hover:bg-white'
      default:
        return 'border-digitalblue transition-all duration-0 hover:duration-200 hover:bg-digitalblue'
    }
  }

  function getButtonTextStyle(type: Nullable<Type>): string {
    switch (type) {
      case 'secondary':
        return 'text-white hover:text-digitalblue'
      default:
        return 'text-digitalblue hover:text-white'
    }
  }
}

LTButton.defaultProps = {
  className: '',
  type: 'primary',
  action: 'button',
  children: [],
  onClick: () => {
    return
  }
}
